import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons.jsx";
import { AlignCenter } from "lucide-react";
import { RiAlignItemBottomFill } from "react-icons/ri";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "90%",

      rows: {
        row1: [
          {
            name: "loadingPercentage",
            label: "Loading",
            component: "text-field",
            width: "17%",
            dataType: "float"
          },
          {
            name: "test",
            actionText: "%on",
            component: "typographytext",
            sx: {
              mt: "35px"

            }
          },
          {
            name: "loadingPercentageOn",
            component: "dropdown",
            width: "17%",
            options: [
              { label: "Job", value: "Job" },


            ],

          },
          {
            name: "USD",
            actionText: "+USD",
            component: "typographytext",
            sx: {
              mt: "35px"

            }
          },
          {
            name: "loadingCount",
            component: "text-field",
            width: "17%",
            dataType: "int"

          },
          {
            name: "Nos",
            actionText: "/Nos ",
            component: "typographytext",
            sx: {
              mt: "35px"

            }
          },
          {
            name: "Nos",
            actionText: "=USD",
            component: "typographytext",
            sx: {
              mt: "35px"

            }
          },
          {
            name: "loadingTotal",
            component: "text-field",
            width: "17%",
            dataType: "float"
          },




        ],

        row2: [
          {
            name: "loadingSVBLoading",
            checkboxLabel: "SVB Loading",
            component: "checkboxBox",
            options: [
              { label: "true", value: true },
              { label: "false", value: false },


            ],

          },
        ],
        row3: [
          {
            name: "loadingSVBRefNo",
            label: "SVB Ref No.",
            component: "text-field",
            width: "30%",

          },
          {
            name: "loadingSVBRefDate",
            component: "DateSelector",
            width: "30%",
          },


        ],
        row4: [
          {
            name: "loadingCustomHouse",
            label: "Custom House",
            component: "text-field",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCustomeHouse",
            width: "61.5%",


          },


        ],
        row5: [
          {
            name: "loadingOn",
            label: "Loading On",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            width: "61.5%",
            options : [
              {label : "Assessable",value : "Assessable"},
              {label : "Duty" , value : "Duty"},
              {label : "Assessable & Duty", value :"Assessable & Duty" }
            ]
          },
        ],
        row6: [
          {
            name: "loadingRateAssible",
            label: "Rate(Assbl)",
            component: "text-field",
            width: "30%",
            dataType: "float"

          },
          {
            name: "loadingRateAssbleStatus",
            label: "Status",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            width: "30%",
            options: [
              { label: "Provisional", value: "Provisional" },
              { label: "Final", value: "Final" },


            ],



          },


        ],
        row7: [
          {
            name: "loadingRateDuty",
            label: "Rate(Duty)",
            component: "text-field",
            width: "30%",
            dataType: "float"

          },
          {
            name: "loadingRateDutyStatus",
            label: "Status",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            width: "30%",
            options: [
              { label: "Provisional", value: "Provisional" },
              { label: "Final", value: "Final" },
            ],
          },
        ],

      }
    }
  ]
}